export default {
  "this field is required": "This field is required",
  "invalid CPF": "Invalid CPF",
  "invalid CNPJ": "Invalid CNPJ",
  "invalid email": "Invalid email",
  "invalid phone": "Invalid phone",
  "invalid password": "Invalid password",
  "invalid slug": "Invalid slug",
  "invalid url": "Invalid url",
  "select item": "Select item",
  "size bigger": "Size is bigger",
  "invalid type": "Invalid type",
  "invalid same": "The fields need to be equals"
};
